import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { filter, map, Observable, take } from "rxjs";
import { UserOrganizationsStore } from "../../domain/organization/application/user-organizations.store";

/**
 * Lets only the organization's admins and coordinators open its management pages (the `:id`
 * route param); everyone else goes to /403. Without it, anyone could open another
 * organization's manage page and only find out when an API call was refused.
 */
export function orgManagerGuard(
  route: ActivatedRouteSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> {
  const userOrgsStore = inject(UserOrganizationsStore);
  const router = inject(Router);
  const orgId = route.paramMap.get("id")!;

  const decide = () => userOrgsStore.canManage(orgId) || router.createUrlTree(["/403"]);

  if (userOrgsStore.isLoaded()) return decide();

  userOrgsStore.load();
  return toObservable(userOrgsStore.isLoaded).pipe(filter(Boolean), take(1), map(decide));
}
